module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-qy.0f1121bb.png";